module.exports = __webpack_public_path__ + "public/img/shouru.b04ce586.png";